<template>
  <div class="picker fit-content">
    <div
      data-grid="nowrap"
      class="picker__wrapper"
    >
      <button
        class="picker__getcolor border-none h-100"
        @click.stop="pickColor"
      />

      <label
        data-grid
        class="picker__label p-relative grid--center grid--va-center text-uppercase cursor-pointer"
      >
        <input
          ref="colorField"
          v-model="_color"
          type="color"
          class="picker__color opacity-0 border-none p-absolute"
          v-bind="{
            id,
            name,
            disabled,
            required
          }"
        >

        {{ _color }}
      </label>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'ColorPicker',

  props: {
    id: {
      type: String,
      default: () => ''
    },

    name: {
      type: String,
      default: () => ''
    },

    disabled: Boolean,

    required: Boolean,

    color: {
      type: String,
      default: () => '#000',
      validator (color) {
        return /#[a-f\d]{3}(?:[a-f\d]{3})?\b/gi.test(color)
      }
    }
  },

  emits: [
    'update:color'
  ],

  setup () {
    const colorField = ref(null)

    return {
      colorField,
      hasEyeDropperAPI: false,
      ...(window.EyeDropper && {
        hasEyeDropperAPI: true,
        eyeDropper: new window.EyeDropper()
      })
    }
  },

  computed: {
    _color: {
      get () {
        return this.color
      },

      set (color) {
        this.$emit('update:color', color)
      }
    }
  },

  methods: {
    async pickColor () {
      if (!this.hasEyeDropperAPI) {
        return this.colorField.click()
      }

      try {
        const color = await this.eyeDropper.open()

        this._color = color.sRGBHex
      } catch (error) {
        // picker was closed
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .picker {
    &__wrapper {
      gap: 10px;
      padding: 8px;
      height: 42px;
      border-radius: 42px;
      border: solid 1px rgb(var(--blue2));
    }

    &__getcolor {
      aspect-ratio: 1;
      border-radius: 26px;
      background-color: v-bind(color);
      border: solid 1px rgb(var(--black));
    }

    &__label {
      width: 65px;
      letter-spacing: .05rem;
      color: rgb(var(--gray16));
      font: 400 1.4rem / 2rem "Nunito", sans-serif;
    }

    &__color {
      width: 1px;
      height: 1px;
      visibility: hidden;

      top: 50%;
      left: 50%;
      transform: translate(50%, 50%);
    }
  }
</style>
